import Login from '../views/authentication/login';
import Login2 from '../views/authentication/login2';
import Register from '../views/authentication/register';
import Register2 from '../views/authentication/register2';
import Lockscreen from '../views/authentication/lockscreen';
import Recoverpwd from '../views/authentication/recover-pwd';
import Maintanance from '../views/authentication/maintanance';
import ForgotPassword from '../views/authentication/forgot-password';
import SignUp from '../views/authentication/signup';
import AcceptTerms from '../views/authentication/accept-terms';

var authRoutes = [
    { path: '/authentication/login', name: 'Login', icon: 'mdi mdi-account-key', component: Login },
    { path: '/authentication/login2', name: 'Login with Firebase', icon: 'mdi mdi-account-key', component: Login2 },
    { path: '/authentication/register', name: 'Register', icon: 'mdi mdi-account-plus', component: Register },
    { path: '/authentication/register2', name: 'Register with Firebase', icon: 'mdi mdi-account-plus', component: Register2 },
    { path: '/authentication/lockscreen', name: 'Lockscreen', icon: 'mdi mdi-account-off', component: Lockscreen },
    { path: '/authentication/recover-pwd', name: 'Recover Password', icon: 'mdi mdi-account-convert', component: Recoverpwd },
    { path: '/authentication/maintanance', name: 'Maintanance', icon: 'mdi mdi-pencil-box-outline', component: Maintanance },
    { path: '/authentication/forgot-password', name: 'Forgot Password', icon: 'mdi mdi-pencil-box-outline', component: ForgotPassword },
    // The public sign-up page ("Start a free trial") and a company admin's Terms and Conditions page (app.js mounts both)
    { path: '/signup', name: 'Sign up', icon: 'mdi mdi-account-plus', component: SignUp },
    { path: '/accept-terms', name: 'Terms and Conditions', icon: 'mdi mdi-file-document', component: AcceptTerms }
];
export default authRoutes;